// Bella Vita — English strings (secondary language).
// Same shape as ar.js. Keep keys in sync across both files.
export default {
  _dir: 'ltr',
  _name: 'English',

  common: {
    book: 'Book',
    book_appointment: 'Book your appointment',
    browse_services: 'Browse services',
    next: 'Continue',
    back: 'Back',
    edit: 'Edit',
    add: 'Add',
    added: 'Added',
    details: 'Details',
    remove: 'Remove',
    retry: 'Try again',
    done: 'Done',
    loading: 'Loading…',
    error_generic: 'We could not load this. Check your connection and try again.',
    empty_generic: 'Nothing to show yet.',
    min: 'min',
    from: 'from',
    skip_to_content: 'Skip to content',
    account: 'My account',
  },

  nav: { home: 'Home', services: 'Services', about: 'About', contact: 'Contact' },

  booking: {
    party_title: 'Party size',
    party_sub: 'How many people is this booking for? (max 4)',
    person: 'Person',
    add_person: 'Add person',
    person_one: 'person',
    person_other: 'people',
    services_title: 'Choose services',
    services_sub: 'Pick services for each person. Your picks appear as “My Services”.',
    myservices: 'My Services',
    specialist_title: 'Choose a specialist',
    specialist_sub: 'Pick who you prefer, or leave it as “No preference”.',
    any_specialist: 'No preference',
    specialist_role: 'Specialist',
    date_title: 'Choose a date',
    date_sub: 'The calendar shows Bella Vita’s available days.',
    cal_prev_month: 'Previous month',
    cal_next_month: 'Next month',
    cal_selected: 'Selected',
    cal_has_slots: 'Has slots',
    cal_today: 'Today',
    slots_empty: 'No times available on this day.',
    time_title: 'Choose a time',
    time_sub: 'Available times for the selected day.',
    customer_title: 'Your details',
    customer_sub: 'We need your mobile and email for your native Odoo Portal account and booking.',
    review_title: 'Review booking',
    review_sub: 'Check the details before payment.',
    pick_service_first: 'Pick at least one service to continue.',
    added: 'Added to My Services',
    step_party: 'Party', step_services: 'Services', step_specialist: 'Specialist',
    step_date: 'Date', step_time: 'Time', step_customer: 'Details', step_review: 'Review',
    party_hint: 'You can assign different services to each person in the next step.',
    all_categories: 'All',
    time_pick_date_first: 'Choose a date first.',
    name_label: 'Name', name_ph: 'Full name',
    mobile_label: 'Mobile number',
    email_label: 'Email',
    notes_label: 'Notes (optional)', notes_ph: 'Anything that helps the team',
    sms_hint: 'We’ll text you the booking confirmation.',
    no_account_hint: 'To confirm, sign in or create your Bella Vita account through secure Odoo authentication.',
    review_specialist: 'Specialist', review_appointment: 'Appointment', review_your_details: 'Your details',
    step_progress: 'Step',
    morning: 'Morning', afternoon: 'Afternoon', evening: 'Evening',
    promo_title: 'Discount code', promo_placeholder: 'Enter code', promo_apply: 'Apply', promo_remove: 'Remove', promo_applied: 'Discount applied', promo_invalid: 'This discount code is invalid or unavailable for this booking.',
    subtotal: 'Subtotal', discount: 'Discount',
    vat: 'VAT',
    total: 'Total',
    duration: 'Duration',
    deposit: 'Amount due now',
    pay_at_salon: 'Balance at the salon',
  },

  account: {
    login_title: 'Log in',
    guest_cta: 'Continue as guest',
    my_bookings: 'My bookings',
    upcoming: 'Upcoming',
    past: 'Past',
    profile: 'Profile',
    ref: 'Reference',
    with: 'with',
    view_booking: 'View booking',
    status_upcoming: 'Upcoming',
    status_completed: 'Completed',
    status_confirmed: 'Confirmed',
    status_cancelled: 'Cancelled',
    welcome: 'Hi',
    account_home: 'My account',
    total_bookings: 'Total bookings',
    member: 'Bella Vita member',
    book_new: 'Book a new appointment',
    none_upcoming: 'No upcoming appointments',
    none_bookings: 'No bookings yet',
    logout: 'Log out',
    booking_detail: 'Booking detail',
    reschedule: 'Reschedule',
    cancel_booking: 'Cancel booking',
    cancel_confirm_title: 'Cancel this booking?',
    cancel_confirm_body: 'This appointment will be cancelled and cannot be undone.',
    cancel_confirm_cta: 'Confirm cancellation',
    keep: 'Keep booking',
    cancelled_toast: 'Booking cancelled',
    book_again: 'Book again',
    when: 'When',
    filter_all: 'All',
    sync_note: 'Internal sync with the Bella Vita calendar only.',
    profile_title: 'Profile',
    profile_note: 'Editing your details will be available later.',
    gate: 'Log in to access your account.',
  },


  checkout: {
    header: 'Checkout', header_sub: 'Review & pay',
    title: 'Review your booking', sub: 'Confirm the details, then choose how to pay.',
    blk_services: 'My Services', blk_appt: 'Appointment & specialist', blk_customer: 'Customer',
    date: 'Date', time: 'Time', specialist: 'Specialist',
    terms: 'I agree to Bella Vita’s booking, cancellation and terms of service.',
    to_pay: 'Continue to payment', pay_short: 'Payment', agree_first: 'Please agree to the terms.',
    incomplete: 'Complete the booking steps first.',
  },

  payment: {
    header: 'Payment', header_sub: 'Complete booking payment',
    method_title: 'Payment method',
    method_sub: 'Service bookings are paid in full to confirm the appointment.',
    pay_deposit: 'Pay now', pay_short: 'Pay',
    confirm_no_pay: 'Confirm without paying now',
    choose_method: 'Choose a payment method.',
    failed: 'We could not complete the booking. Please try again.',
    provider_failed: 'Your appointment is temporarily saved, but the payment provider could not be opened. Please retry payment.',
    method_unavailable: 'The selected payment method is no longer available for this booking.',
    retry_payment: 'Your booking is saved, but payment did not complete. You can retry without creating another booking.',
    secure_note: 'Payment is completed on the provider’s secure checkout. Bella Vita does not collect or store your card details.',
    mock_note: 'Mock UI only — no charge is made and no card data is collected in this prototype.',
    auth_invite: 'Your details match an existing customer record. Activate Odoo Portal on that same record so your booking history stays in one account.',
    auth_invite_cta: 'Send account activation link',
    auth_invite_sent: 'The activation link was sent to the email already on file. Set your password, then sign in to return to this booking.',
    auth_login_cta: 'Sign in',
    auth_conflict: 'We could not safely match these details to one account. Use sign in or password reset, or contact the salon.',
    auth_reset_cta: 'Reset password',
    auth_invite_failed: 'We could not safely send the activation link. Use sign in or password reset.',
  },

  confirmation: {
    header: 'Confirmed',
    title: 'Your booking is confirmed',
    texted: 'We’ve texted the details to',
    appt_details: 'Appointment details',
    date_time: 'Date & time',
    deposit_paid: 'Deposit paid',
    payment_status: 'Payment status',
    payment_verifying: 'Verifying payment…',
    payment_paid: 'Payment completed',
    payment_failed: 'Payment not completed',
    payment_pending: 'Payment verification pending',
    retry_payment: 'Retry payment',
    account_home: 'My account',
    book_again: 'Book again',
    sync_note: 'The appointment syncs internally with the Bella Vita calendar. No external calendar is shown.',
    none_title: 'Nothing to show',
    none_cta: 'Book an appointment',
  },

  notfound: { title: 'Page not found', cta: 'Back to home' },

  footer: {
    tagline: 'One salon. A calm, considered beauty experience in the heart of the city.',
    explore: 'Explore',
    services: 'Services',
    book: 'Book',
    account: 'My account',
    salon: 'Salon',
    address: 'Address — owner data',
    hours: 'Hours — owner data',
    contact: 'Contact',
    phone: 'Phone / WhatsApp — owner data',
    instagram: 'Instagram — owner data',
    rights: '© 2026 Bella Vita',
    one_salon: 'One salon',
  },

  home: {
    hero_eyebrow: 'Bella Vita salon',
    hero_title: 'Beauty you deserve — calm and considered',
    hero_sub: 'Book in minutes. Choose your services, your specialist, and a time that suits you.',
    cta_book: 'Book your appointment',
    cta_services: 'Browse services',
    why_eyebrow: 'Why Bella Vita',
    why_lead: 'One space, one team, and a high standard in every detail.',
    value_1: 'Instant, flexible booking',
    value_2: 'Hand-picked specialists',
    value_3: 'Premium, safe products',
    collections_eyebrow: 'Services',
    collections_title: 'Our care collections',
    all_services: 'All services',
    clients_title: 'From our clients',
    quote: '“A calm, organised experience from booking to the end of the session.”',
    quote_cite: 'Bella Vita client',
  },

  services: {
    eyebrow: 'Services',
    title: 'Services & prices',
    lead: 'Prices in Saudi Riyal, VAT-inclusive where it applies. Latin digits.',
    all: 'All',
    count_suffix: 'services',
    empty: 'No services in this category yet.',
  },

  detail: {
    desc: 'A complete care session by the Bella Vita team with selected products.',
    fact_from: 'from',
    fact_daily: 'Daily',
    fact_availability: 'availability',
    book_this: 'Book this service',
    back: 'Back',
    includes_title: 'What the session includes',
    include_1: 'A short consultation before we start',
    include_2: 'Selected care products',
    include_3: 'Sanitised steps and clean tools',
    include_4: 'Aftercare tips for home',
    not_found: 'Service not found',
  },
};
